import {
  APP_DETAILS_SUCCESS,
  APP_RECOMMEND_SUCCESS,
  APP_GROUP_SUCCESS,
  APP_DETAILS_GIFT_SUCCESS,
  APP_DETAILS_GIFT_RECEIVE_SUCCESS,
  APP_FORUM_RELATED_SUCCESS,
} from '../constants/detail';

const initState = {
  appDetails: {},
  appRecommend: {
    apps: [],
  },
  detailGroups: null,
  detailGift: {},
  receiveGift: {},
  forumRelated: {},
};

const detail = (state = initState, action = {}) => {
  switch (action.type) {
    case APP_DETAILS_SUCCESS:
      return { ...state, appDetails: action.payload };
    case APP_RECOMMEND_SUCCESS:
      return { ...state, appRecommend: action.payload };
    case APP_GROUP_SUCCESS:
      return { ...state, detailGroups: action.payload };
    case APP_DETAILS_GIFT_SUCCESS:
      return { ...state, detailGift: action.payload };
    case APP_DETAILS_GIFT_RECEIVE_SUCCESS:
      return { ...state, receiveGift: action.payload };
    case APP_FORUM_RELATED_SUCCESS:
      return { ...state, forumRelated: action.payload };
    default:
      return state;
  }
};

export default detail;
